var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-wrapper auth-v1"},[_c('div',{staticClass:"auth-inner2"},[_c('v-card',{staticClass:"my-12 px-6 py-6"},[_c('v-card-title',[_c('p',{staticClass:"mb-2 mb-sm-0"},[_vm._v(" 支払い情報 ")])]),_c('PaymentComponentVue')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }